import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import lodashGet from "lodash.get";
import { Img, GridColumn } from "arv-reactcomponents";

import { imageFileName } from "../../../utils";
import TrendingBannerContainer from "../TrendingBannerContainer";
import SpecialBannerComponent from "../SpecialBannerComponent";

@inject("CommonStore")
@observer
class BannerComponent extends Component {
  render() {
    const {
      bannerObject,
      gridClassName,
      imgClassName,
      trendingBannerObject,
      trendingBannerContainerClassName,
      trendingBannerImgClassName,
      trendingBannerSlotClassName,
      specialBannerContainerClassName,
      specialBannerImgClassName,
      specialBannerButtonClassName,
      showBanner,
    } = this.props;
    const { isDesktop } = this.props.CommonStore;
    const banner = lodashGet(bannerObject, "banner1.image.path");

    return isDesktop && showBanner ? (
      <GridColumn className={`nwc-grid-col-sm ${gridClassName}`}>
        {banner ? (
          <Img
            src={banner}
            alt={imageFileName(banner)}
            className={imgClassName}
          />
        ) : null}
        <TrendingBannerContainer.component
          trendingBannerObject={trendingBannerObject}
          bannerContainerClassName={trendingBannerContainerClassName}
          bannerSlotClassName={trendingBannerSlotClassName}
          bannerImgClassName={trendingBannerImgClassName}
        />
        <SpecialBannerComponent.component
          bannerObject={bannerObject}
          bannerContainerClassName={specialBannerContainerClassName}
          bannerImgClassName={specialBannerImgClassName}
          bannerButtonClassName={specialBannerButtonClassName}
        />
      </GridColumn>
    ) : null;
  }
};

BannerComponent.wrappedComponent.propTypes = {
  bannerObject: PropTypes.shape({}).isRequired,
  gridClassName: PropTypes.string.isRequired,
  imgClassName: PropTypes.string.isRequired,
  trendingBannerContainerClassName: PropTypes.string.isRequired,
  trendingBannerSlotClassName: PropTypes.string.isRequired,
  trendingBannerImgClassName: PropTypes.string.isRequired,
  specialBannerContainerClassName: PropTypes.string.isRequired,
  specialBannerImgClassName: PropTypes.string.isRequired,
  specialBannerButtonClassName: PropTypes.string.isRequired,
  trendingBannerObject: PropTypes.arrayOf({
    brandId: PropTypes.string.isRequired,
    productListingUrl: PropTypes.string.isRequired,
    images: PropTypes.shape({
      logo: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  showBanner: PropTypes.bool.isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: BannerComponent.wrappedComponent,
  component: BannerComponent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/BannerComponent/index.js